import React, { useEffect, useState } from 'react';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { classNames } from '../DatePicker/helpers';
interface ICard {
  children: JSX.Element;
  onClick?: any;
  card?: any;
}

const Card: React.FC<ICard> = ({ children, onClick }) => {
  return (
    <div
      className={tw`w-full bg-white rounded-md  mb-8`}
      style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}
    >
      <div className={tw`h-full cursor-pointer`} onClick={onClick}>
        {children}
      </div>
    </div>
  );
};

export default Card;
